
/* injects from baggage-loader */

'use strict';

export default class AccountDocumentRequestReviewController {

	constructor($log, $state, $stateParams, Alerts, LoadingCover, DocumentRequest) {
		'ngInject';

		this.$log = $log;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.alerts = Alerts;
		this.LoadingCover = LoadingCover;
		this.DocumentRequest = DocumentRequest;

	}

	$onInit() {

		// Setup loading cover
		this.savingDocumentRequestLoadingCover = this.LoadingCover.getInstance('saving-document-request');

		this.$log.debug(this.documentRequest);

		// Check if an action was passed in the querystring
		if (this.$stateParams.action && this.documentRequest.status === 'pending') {
			this.$log.debug('Process action:', this.$stateParams.action);

			if (this.$stateParams.action === 'approve') {
				this.approveRequest(true);
			} else if (this.$stateParams.action === 'deny') {
				this.denyRequest(true);
			} else if (this.$stateParams.action === 'revoke') {
				this.revokeRequest(true);
			} else {
				// Unknown action
			}

		}

	}

	approveRequest(stayPut) {

		this.savingDocumentRequestLoadingCover.show('Saving decision');

		// Set status "approved" and save
		this.documentRequest.save({
			status: 'approved'
		})
			.then(req => {

				this.savingDocumentRequestLoadingCover.complete('Request approved')
					.then(() => {

						// Return to document requests page
						if (!stayPut) {
							this.$state.go('account.document-requests', { status: 'pending' });
						}

					});

			});

	}

	denyRequest(stayPut) {

		this.savingDocumentRequestLoadingCover.show('Saving decision');

		// Set status "denied" and save
		this.documentRequest.save({
			status: 'denied'
		})
			.then(req => {

				this.savingDocumentRequestLoadingCover.complete('Request denied')
					.then(() => {

						// Return to document requests page
						if (!stayPut) {
							this.$state.go('account.document-requests', { status: 'pending' });
						}

					});

			});

	}

	revokeRequest(stayPut) {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account/document-request-review/account.document-request-review.controller.js